import { render, staticRenderFns } from "./TekshiruvOylikXisobot.vue?vue&type=template&id=1715cd8d&scoped=true"
import script from "./TekshiruvOylikXisobot.vue?vue&type=script&lang=js"
export * from "./TekshiruvOylikXisobot.vue?vue&type=script&lang=js"
import style0 from "./TekshiruvOylikXisobot.vue?vue&type=style&index=0&id=1715cd8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1715cd8d",
  null
  
)

export default component.exports